import { render, staticRenderFns } from "./DocusignAddTemplateAdditionalDocument.vue?vue&type=template&id=415a545d&"
import script from "./DocusignAddTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"
export * from "./DocusignAddTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports